import type { ReactNode } from 'react'
import { useIsDesktop } from '@/hooks/useMediaQuery'
import { DesktopLayout } from './DesktopLayout'
import { MobileLayout } from './MobileLayout'

interface AppShellProps {
  /** Primary workspace (chart / trade view). */
  main: ReactNode
  /** Desktop right rail (order ticket). */
  right?: ReactNode
  /** Desktop bottom panel (blotter / positions). */
  bottom?: ReactNode
  /** Mobile-only stacked content override; defaults to main + right + bottom. */
  mobile?: ReactNode
}

/**
 * Responsive layout engine:
 * - ≥1024px → institutional multi-column desktop terminal
 * - <1024px (or installed PWA on phone) → native-like mobile shell
 */
export function AppShell({ main, right, bottom, mobile }: AppShellProps) {
  const isDesktop = useIsDesktop()

  if (isDesktop) {
    return <DesktopLayout main={main} right={right} bottom={bottom} />
  }

  return (
    <MobileLayout>
      {mobile ?? (
        <div className="flex h-full min-h-0 flex-col">{main}</div>
      )}
    </MobileLayout>
  )
}
